import React, { useRef, useState, useEffect } from "react"
import styled from "styled-components"
import { colors } from "../../utils/theme"

const CounterDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0rem 0.5rem 0rem 0.5rem;
  margin: 0rem auto 0 auto;
  position: relative;
  max-width: 300px;
  color: white;
  position: relative;
  background: rgba(0, 0, 0, 0);
  z-index: 10;
  @media (max-width: 900px) {
    padding: 0.5rem 0.5rem;
    margin: 0 auto;
    position: relative;
    left: inherit;
    top: inherit;
  }
  @media (max-width: 600px) {
    padding: 0.5rem 0.5rem;
    margin: 0 auto;
    position: relative;
    left: inherit;
    top: inherit;
  }
  & .days {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      height: 60%;
      width: 2px;
      background: ${colors.sColor};
    }
  }
  & .hours {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      height: 60%;
      width: 2px;
      background: ${colors.sColor};
    }
  }
  & .minutes {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      height: 60%;
      width: 2px;
      background: ${colors.sColor};
    }
  }
  & .title-counter {
    position: absolute;
    top: -17px;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px 10px;
    background: #5827b6;
    font-size: 0.8em;
    font-weight: 600;
    @media (max-width: 600px) {
      width: 60%;
      text-align: center;
    }
  }
  & .col-counter {
    width: 33.3%;
    padding: 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 0.8em;
    text-transform: uppercase;
    @media (max-width: 600px) {
      font-size: 0.7em;
    }
  }
  & .value {
    font-weight: 700;
    font-size: 1.5em;
    @media (max-width: 600px) {
      font-size: 1.2em;
    }
  }
`
const Counter = ({ date }) => {
  const [days, setDays] = useState(12)
  const [hours, setHours] = useState(12)
  const [minutes, setMinutes] = useState(12)
  const [seconds, setSeconds] = useState(12)
  const [counterStatus, setCounterStatus] = useState(true)

  // Set the date we're counting down to "Apr 21, 2021 0:0:0"
  var countDownDate = new Date(date).getTime()

  // Update the count down every 1 second
  const counter = () =>
    setInterval(function () {
      // Get today's date and time
      let now = new Date().getTime()

      // Find the distance between now and the count down date
      let distance = countDownDate - now

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24))
      let hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((distance % (1000 * 60)) / 1000)

      //Poner valores
      setDays(days)
      setHours(hours)
      setMinutes(minutes)
      setSeconds(seconds)

      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(counter)
        setCounterStatus(false);
      }
    }, 1000)

  useEffect(() => {
    counter()
  }, [])

  return (
    <>
      {counterStatus ? (
        <CounterDiv>
          <div className="col-counter days">
            <span> Días </span>
            <span className="value" id="value-days">
              {days}
            </span>
          </div>
          <div className="col-counter hours">
            <span> Horas </span>
            <span className="value" id="value-hours">
              {hours}
            </span>
          </div>
          <div className="col-counter minutes">
            <span> Min </span>
            <span className="value" id="value-minutes">
              {minutes}
            </span>
          </div>
          <div className="col-counter seconds">
            <span> Segs </span>
            <span className="value" id="value-seconds">
              {seconds}
            </span>
          </div>
        </CounterDiv>
      ) : (
        <CounterDiv>
          <h4
            style={{
              width: "100%",
              margin: "0",
              padding: "1em 0",
              fontWeight: "800",
            }}
            className="text-center"
          >
            Este curso ya inició <br></br>
            <span
              style={{
                fontSize: ".7em",
                fontWeight: "500",
                textTransform: "uppercase",
              }}
            >
              Inicio el: {date}
            </span>
          </h4>
        </CounterDiv>
      )}
    </>
  )
}

export default Counter
